import { render, staticRenderFns } from "./Tables.vue?vue&type=template&id=c28fe706&scoped=true&"
import script from "./Tables.vue?vue&type=script&lang=ts&"
export * from "./Tables.vue?vue&type=script&lang=ts&"
import style0 from "./Tables.vue?vue&type=style&index=0&id=c28fe706&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28fe706",
  null
  
)

export default component.exports